<template>
  <b-card :title="labels.title">
    <div v-if="loadingSlack" class="loading">
      <Loading />
      <p>{{ labels.loading }}</p>
    </div>
    <div v-if="loadingSlackConnect" class="loading">
      <Loading />
      <p>{{ labels.loadingConnect }}</p>
    </div>
    <div v-if="showConnect">
      <b-card-text>{{ labels.text }}</b-card-text>
    </div>
    <div class="mt-3" v-if="slack">
      <b-card-text v-if="slack.length === 1">
        {{ labels.textConnected }}
      </b-card-text>
      <b-card-text v-else>
        {{ labels.textConnectedPlural }}
      </b-card-text>
      <ol>
        <li v-for="(workspace, idx) in slack" :key="`${workspace.id}-${idx}`">
          <span class="workspace">{{ workspace.name }}</span>
          <i
            :id="`delete-slack-workspace-${idx}`"
            class="material-icons text-primary delete-workspace ml-2"
            @click="doDelete(workspace)"
          >
            delete
          </i>
          <b-tooltip :target="`delete-slack-workspace-${idx}`">
            <div class="tooltip-info">
              {{ resources.general.buttons.delete }}
            </div>
          </b-tooltip>
        </li>
      </ol>
      <b-alert show variant="danger" class="slack-info">
        {{ labels.textConnectedInfo }}
      </b-alert>
      <b-alert
        show
        variant="warning"
        class="slack-info"
        v-if="slack.length > 1"
      >
        {{ labels.textConnectedWarn }}
      </b-alert>
    </div>
    <template v-slot:footer v-if="showConnect">
      <a :href="addToSlackUrl" class="float-right">
        <img
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          srcset="
            https://platform.slack-edge.com/img/add_to_slack.png    1x,
            https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
          "
        />
      </a>
    </template>
  </b-card>
</template>

<script>
import Loading from '@/components/Shared/Loading.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Loading,
  },

  props: {
    slack: {
      type: Array,
      default: null,
    },
    loadingSlack: {
      type: Boolean,
      default: false,
    },
    loadingSlackConnect: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.home.integrations.slack
    },
    showConnect() {
      return !this.loadingSlack && !this.loadingSlackConnect
    },
    addToSlackUrl() {
      const SLACK_API_OAUTH = 'https://slack.com/oauth/authorize'
      const scope = 'bot'
      const client_id = '438108064834.438110483922'
      const redirect_uri = `${window.location.origin}/integrations`
      const state = 'from-slack'
      return `${SLACK_API_OAUTH}?scope=${scope}&client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}`
    },
  },

  methods: {
    doDelete(workspace) {
      this.$emit('deleteWorkspace', workspace)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.loading {
  margin: 0 auto;
  text-align: center;
}

.workspace {
  font-size: 1.25em;
  color: map-get($theme-colors, 'primary');
}
.delete-workspace {
  cursor: pointer !important;
}

.slack-info {
  position: relative !important;
  font-size: 15px !important;
}
</style>
